module.exports = __webpack_public_path__ + "static/3-30340c82691bd5a51980e489dd8e190a.jpeg";